import { NgStyle } from '@angular/common'
import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

@Component({
  selector: 'wm-front-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgStyle],
})
export class ProgressBarComponent {
  /** Total amount */
  @Input() public total: number = 1

  /** Progress amount */
  @Input() public progress: number = 0
}
